<template>
  <el-dialog
    :title="$t('text.select_data_region')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    custom-class="region-selection-dialog"
    width="460px"
  >
    <p class="region-selection-description">
      {{ $t('text.select_region_description') }}
    </p>
    <div class="region-selection-wrapper">
      <el-radio-group v-if="regions.length" v-model="selectedRegion">
        <el-radio
          v-for="region in regions"
          :key="region.code"
          :label="region.code"
          class="region-selection-item"
        >
          <span class="region-code-badge">{{ region.code }}</span>
          <span class="region-details">
            <span class="region-name">{{ region.name || region.code }}</span>
          </span>
          <i class="el-icon-check region-check"></i>
        </el-radio>
      </el-radio-group>
      <div v-else class="v-h-center p-10 secondary-font">
        {{ $t('text.no_data') }}
      </div>
    </div>
    <div slot="footer" class="region-selection-footer">
      <el-button
        class="save-btn region-continue-button"
        :loading="loading"
        :disabled="!selectedRegion"
        @click="$emit('select', selectedRegion)"
      >
        {{ $t('text.continue').toUpperCase() }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    regions: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      selectedRegion: ''
    }
  },
  methods: {
    openDialog() {
      this.selectedRegion = this.regions.length ? this.regions[0].code : ''
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.region-selection-description {
  margin: -2px 0 20px;
  color: #606f7b;
  font-size: 14px;
  line-height: 1.55;
  text-align: left;
}

.region-selection-wrapper::v-deep {
  .el-radio-group {
    width: 100%;

    .el-radio {
      display: flex;
      align-items: center;
      width: 100%;
      margin-bottom: 12px !important;
    }
  }

  .region-selection-item {
    position: relative;
    min-height: 76px;
    padding: 14px 48px 14px 16px;
    overflow: hidden;
    border: 1px solid #dfe7ed;
    border-radius: 8px;
    background: #fff;
    box-sizing: border-box;
    cursor: pointer;
    text-align: left;
    transition: border-color 0.2s ease, background-color 0.2s ease,
      box-shadow 0.2s ease;

    &:hover {
      border-color: #98c1d9;
      box-shadow: 0 4px 14px rgba(52, 92, 116, 0.1);
    }

    .el-radio__input {
      display: none;
    }

    .el-radio__label {
      display: flex;
      align-items: center;
      width: 100%;
      padding-left: 0;
      color: #34495e;
    }

    &.is-checked {
      border-color: #6ca9ca;
      background: #f1f8fc;
      box-shadow: 0 4px 14px rgba(52, 92, 116, 0.13);

      .el-radio__label {
        color: #34495e;
      }

      .region-code-badge {
        color: #fff;
        background: #6ca9ca;
      }

      .region-check {
        opacity: 1;
        transform: translateY(-50%) scale(1);
      }
    }
  }

  .region-code-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 48px;
    height: 48px;
    margin-right: 14px;
    border-radius: 50%;
    color: #52778d;
    background: #eaf3f8;
    font-size: 15px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    transition: color 0.2s ease, background-color 0.2s ease;
  }

  .region-details {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  .region-name {
    font-size: 16px;
    font-weight: 600;
  }

  .region-check {
    position: absolute;
    top: 50%;
    right: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    color: #fff;
    background: #6ca9ca;
    font-size: 14px;
    opacity: 0;
    transform: translateY(-50%) scale(0.7);
    transition: opacity 0.2s ease, transform 0.2s ease;
  }
}

.region-selection-footer {
  width: 100%;
}

.region-continue-button {
  width: 100%;
  height: 42px;
  border-radius: 6px;
}

@media (max-width: 550px) {
  .region-selection-wrapper::v-deep .region-selection-item {
    min-height: 68px;
    padding: 10px 42px 10px 12px;
  }

  .region-selection-wrapper::v-deep .region-code-badge {
    flex-basis: 42px;
    height: 42px;
    margin-right: 11px;
  }
}
</style>
